import { render, staticRenderFns } from "./land-commerce.vue?vue&type=template&id=304e32fc"
import script from "./land-commerce.vue?vue&type=script&lang=js"
export * from "./land-commerce.vue?vue&type=script&lang=js"
import style0 from "./land-commerce.vue?vue&type=style&index=0&id=304e32fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports